module.exports = __webpack_public_path__ + "static/media/logo-ldpi.092c60c4.png";